import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_ESTABLISHMENT_SAGA } from "../sagaTypes";
import { loaderAction, uploadFileAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { establishmentListSagaAction } from "../sagaActions";
import { UPLOAD_FILE_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_establishment`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateEstablishment(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const upload_file = yield select(state => state.upload_file);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('establishment', currentEstablishment);
        formData.append('field', args.data.field);
        formData.append('value', args.data.value);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Запрашиваем список заведений
            yield put(establishmentListSagaAction());
            growl({ type: 'success', message: response.message });

            if (upload_file.name && upload_file.link) {
                yield put(uploadFileAction(UPLOAD_FILE_INITIAL));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateEstablishment() {
    yield takeLatest(UPDATE_ESTABLISHMENT_SAGA, workerUpdateEstablishment);
}